import type { Route } from './router.svelte';

/**
 * La pila de "atrás", sin DOM y sin runas.
 *
 * Vive aparte del router por la misma razón que `toastQueue` vive aparte de
 * `toasts`: la parte que se puede equivocar es la lógica, y aislarla permite
 * probarla sin un navegador.
 *
 * El fallo que motiva este módulo: antes había una sola casilla `previous`, y
 * volver atrás es en sí una navegación, así que al llegar a la pantalla previa
 * esa casilla pasaba a apuntar a la que acababas de dejar. Con menú →
 * configuración → perfil, el botón rebotaba entre configuración y perfil y el
 * inicio quedaba inalcanzable.
 */

/** Tope de la pila. Nadie recorre veinte pantallas hacia atrás. */
export const MAX_HISTORY = 20;

export class NavigationHistory {
  private stack: Route[] = [];

  /**
   * Registra la pantalla que se abandona al avanzar.
   *
   * Sólo se llama en navegaciones nuevas: apilar también al volver es
   * exactamente lo que creaba el bucle.
   */
  push(route: Route): void {
    this.stack.push(route);
    if (this.stack.length > MAX_HISTORY) this.stack.shift();
  }

  /** La pantalla a la que volver, o `null` si ya no hay historial. */
  pop(): Route | null {
    return this.stack.pop() ?? null;
  }

  get depth(): number {
    return this.stack.length;
  }

  clear(): void {
    this.stack.length = 0;
  }
}
